import { connect } from "react-redux";
// Component
import CustomerAdminCard from "components/CustomerDetail/CustomerAdminCard";
// Action
import { openCustomerAdminModal } from "redux/modules/customerDetail";
// Utils
import history from "utils/history";

const mapStateToProps = state => ({
  customerAdminCard: state.customerDetail.customerAdminCard
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  historyPush: path => history.push(path, ownProps),
  openModal: customerAdmin => {
    dispatch(openCustomerAdminModal(customerAdmin));
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(CustomerAdminCard);



// WEBPACK FOOTER //
// ./src/containers/CustomerDetail/CustomerAdminCardContainer.js